module.exports = __webpack_public_path__ + "e54fddf4945778d8f99dfd7e8d7080bb.png";